import ko from '@tko/build.knockout';
import $ from 'jquery';
import _ from 'lodash';
import DashboardService from '../../modules/assurance/services/dashboard.service';
import DataServiceSecure from '../../modules/assurance/services/data-secure.service';
import DataRepositoryManager from './data-repository-manager';
import LoginService from '../../services/login.service';
import AssuranceDataService from '../../modules/assurance/services/data.service';
import PreferenceManager from './preference-manager';
import PreferenceService from '../../services/preference.service';
import ConfigService from '../../services/config.service';
import PermissionService from '../../services/permission.service';

import alertgridFormatter from '../data-formatters/alertgrid-formatter';
import callcontrolstatussearchgridFormatter from '../data-formatters/callcontrolstatussearchgrid-formatter';
import capacitystatusgridFormatter from '../data-formatters/capacitystatusgrid-formatter';
import capacitytrendchartFormatter from '../data-formatters/capacitytrendchart-formatter';
import endpointdetailFormatter from '../data-formatters/endpointdetail-formatter';
import endpointmgmtgridFormatter from '../data-formatters/endpointmgmtgrid-formatter';
import endpointstatusgridFormatter from '../data-formatters/endpointstatusgrid-formatter';
import endpointstatussearchgridFormatter from '../data-formatters/endpointstatussearchgrid-formatter';
import filterFormatter from '../data-formatters/filter-formatter';
import flexipanelFormatter from '../data-formatters/flexipanel-formatter';
import formatterCommon from '../data-formatters/formatter-common';
import genericfilterFormatter from '../data-formatters/genericfilter-formatter';
import gridFormatterCommon from '../data-formatters/grid-formatter-common';
import historicalfilterFormatter from '../data-formatters/historicalfilter-formatter';
import historicalgraphFormatter from '../data-formatters/historicalgraph-formatter';
import integrationsFormatter from '../data-formatters/integrations-formatter';
import kpicellFormatter from '../data-formatters/kpicell-formatter';
import kpimulticellFormatter from '../data-formatters/kpimulticell-formatter';
import kpipanelFormatter from '../data-formatters/kpipanel-formatter';
import licenselinechartFormatter from '../data-formatters/licenselinechart-formatter';
import linechartFormatterCommon from '../data-formatters/linechart-formatter-common';
import logireportFormatter from '../data-formatters/logireport-formatter';
import lyncfilterFormatter from '../data-formatters/lyncfilter-formatter';
import qualitygraphsFormatter from '../data-formatters/qualitygraphs-formatter';
import qualitygridsFormatter from '../data-formatters/qualitygrids-formatter';
import roomgridFormatter from '../data-formatters/roomgrid-formatter';
import scheduledMeetingsFormatter from '../data-formatters/scheduled-meetings-formatter';
import schedulegridFormatter from '../data-formatters/schedulegrid-formatter';
import searchgrid2Formatter from '../data-formatters/searchgrid2-formatter';
import toputilizedgridFormatter from '../data-formatters/toputilizedgrid-formatter';
import xmldetailsFormatter from '../data-formatters/xmldetails-formatter';
import './rdEmbed';
import Promise from 'promise-polyfill';
import { store } from '../../modules/admin/store/index';


var instance = null;

function DataProvider() {
    if (instance !== null) {
        throw new Error('Cannot instantiate more than one DataProvider.');
    }
    var self = this;
    self.refreshPromiseInProgress = true;
    self.resetDataProvider();
    if (!LoginService.isLoginPage() && !LoginService.isLogoutPage()) {
        LoginService.getActiveSession().then((user) => {
            self.setSessionInfo(user, true);
        }, () => {
          LoginService.navigateToLogin();
        });
    }
}

DataProvider.prototype.resetDataProvider = function () {
    var self = this;
    self.dispose();

    self.dataRepositoryManager = new DataRepositoryManager();
    self.dataConsumers = [];
    self.preferenceManager = PreferenceManager;
    self.preferenceManager.setDataProvider(self);
    self.preferences = {};
    self.markedForRemovalList = [];
    self.newsessionHistorical = true; //for use in date-range reset
    self.newsessionWebex = true; //for use in date-range reset
};

DataProvider.prototype.loadFlexQueryMetadata = function () {
    var self = this;
    if ($.isEmptyObject(self.dataRepositoryManager.dataRepository.flexQueryMetaData())) {
        return self.dataRepositoryManager.invokeServiceMethod2("DatabaseMethods.aspx", "GetFlexQueryMetaData", "json", {});
    }
};

DataProvider.prototype.loadEndpointHistoricalInfo = function (epAppsId) {
    var self = this;

    return self.dataRepositoryManager.invokeServiceMethod2("WebexData.aspx", "GetEndpointHistoricalInfo", "json", {
        appsEpId: epAppsId
    });
};

DataProvider.prototype.loadEndpointModels = function () {
    var self = this;

    if ($.isEmptyObject(self.dataRepositoryManager.dataRepository.endpointModels())) {
        return self.dataRepositoryManager.invokeServiceMethod2("DatabaseMethods.aspx", "GetEndpointModels", "json", {});
    }
};

DataProvider.prototype.loadSystems = function (category) {
    var self = this;

    category = category || '*';

    var systems = self.dataRepositoryManager.dataRepository.systemsDictionary();

    if (_.isEmpty(systems[category])) {
        return self.dataRepositoryManager.invokeServiceMethod2("DatabaseMethods.aspx", "GetSystemsList", "json", { page: category });
    }
    return Promise.resolve(systems[category]);
};

DataProvider.prototype.loadFiltersForKey = function (key) {
    var keyFiltersMap = this.dataRepositoryManager.dataRepository.FactFilterDictionary();
    var datasetKey = '{"datasetName":"' + key + '"}';

    if (!_.has(keyFiltersMap, datasetKey)) {
        return this.dataRepositoryManager.invokeServiceMethod2("DatabaseMethods.aspx", "GetFiltersForFactKey", "json", { datasetName: key });
    }

    return Promise.resolve(_.get(keyFiltersMap, datasetKey));
};

// Translates the current route page to the appContext value used for certain components, e.g. panel options
DataProvider.prototype.getCurrentModule = function() {
  let self = this;
  let page = self.currentRouteParams.page;
  switch (page) {
    case 'rooms-app-view': return 'RoomInsights';
    case 'historical2-app-view': return 'AdvancedAnalytics';
    default: return '';
  }
};

DataProvider.prototype.isRoutePermitted = function (routeParams) {
    var self = this;
    var page = routeParams.page;

    if (routeParams.permission && !self.permissionService.hasPermission(routeParams.permission)) {
        return false;
    } else {
        if (routeParams.view === 'settings-view') {
            return self.permissionService.hasPermission(self.permissionService.SettingsViewPermission);
        }
        else if (_.includes(page, 'assurance')) {
            return (LoginService.userObject.email === 'support@vyopta.com' || _.startsWith(LoginService.userObject.email, 'vyoptaadmin@')) || (self.assuranceIsInModules() && pagePermitted(LoginService.userObject, routeParams));
        }
        else if (_.includes(page, 'webex')) {
            return self.webexIsInModules();
        }
        else if (_.includes(page, 'historical2')) {
            if (!self.advancedAnalyticsIsInModules() || (routeParams.view === 'historical2-user-details-view' && LoginService.userObject && LoginService.userObject.featureFlags.UserProfileLinkOptOut)) {
                return false; // Org doesn't have AdvancedAnalytics module enabled
            }
            else if (routeParams.view === 'historical2-dataset-view-rooms' || routeParams.view === 'historical2-roomboard-view') {
                return self.isRoomInsightsInModules();
            }
            else {
                return self.permissionService.hasPermission(self.permissionService.AnalyticsViewPermission);
            }
        }
        else if (_.includes(page, 'lync')) {
            return self.lyncIsInModules();
        }
        else if (_.includes(page, 'historical')) {
            return self.historicalIsInModules();
        }
        else if (_.includes(page, 'rooms')) {
          return self.isRoomInsightsInModules();
        }
        else {
            // probably want to default to false or permission check up top
            return true;
        }
    }
};

function urlIsAppLevel(url) {
    return !/\w*\/.+/.test(url);
}

function urlIsTabLevel(url) {
    return /\/tabid\/([\d\w]+)/.test(url);
}

function pagePermitted(user, routeParams) {
    if (_.isEmpty(routeParams.onlyInModules)) {
        return true;
    }
    if (_.isEmpty(user.modules)) {
        console.warm('No modules for user:', user.name);
        return false;
    }
    return _.some(user.modules.split(","), function (userModule) {
        return _.includes(_.toLower(routeParams.onlyInModules), _.toLower(userModule));
    });
}

DataProvider.prototype.logUnauthorizedURLAccessAttempt = function (routeParams) {
    var self = this;
    self.logActivity2('navigation', routeParams.request_, 'unauthorized url access attempt', {
        prevUrl: routeParams.prevURL
    });
};

DataProvider.prototype.beforeRouting = function (routeParams, islogin) {
    var self = this;
    self.currentRouteParams = routeParams;

    //if is login page don't log but flag this so that next page gets logged with extra details
    if (islogin) {
        self.islogin = true;
    } else {
        if (self.islogin) {
            //self.logActivity(routeParams.request_, '', 'beforeRouting', '', { vendor: navigator.vendor, platform: navigator.platform, userAgent: navigator.userAgent }, '');
            self.logActivity2('navigation', routeParams.request_, '', {
                prevUrl: routeParams.prevURL,
                vendor: navigator.vendor,
                platform: navigator.platform,
                userAgent: navigator.userAgent
            });
        } else {
            //self.logActivity(routeParams.request_, '', 'beforeRouting', '', {}, '');
            self.logActivity2('navigation', routeParams.request_, '', {
                prevUrl: routeParams.prevURL
            });
        }
        self.islogin = false;
    }
};

DataProvider.prototype.isPdfEnabled = function() {
    return LoginService.userObject && LoginService.userObject.enablePdf;
}

DataProvider.prototype.setSessionInfo = function (userInfo, isNewSession) {
    //setup idle timeout if necessary
    const self = this;
    // now that user is full make permission service
    this.permissionService = new PermissionService(userInfo);

    // the preference manager needs to know which modules are available (this avoids a circular reference)
    this.preferenceManager.dispose();
    this.preferenceManager.setAvailableModules(userInfo.modulesDictionary);
};

DataProvider.prototype.webexIsInModules = function () {
    var self = this;
    return LoginService.userObject.isInModules("AnalyticsForWebex");
};

DataProvider.prototype.historicalIsInModules = function () {
    var self = this;
    return LoginService.userObject.isInModules("vAnalyticsHistorical");
};

DataProvider.prototype.assuranceIsInModules = function () {
    var self = this;
    return LoginService.userObject.isInModules('Assurance');
};

DataProvider.prototype.advancedAnalyticsIsInModules = function () {
    var self = this;
    return LoginService.userObject.isInModules("AdvancedAnalytics");
};

DataProvider.prototype.lyncIsInModules = function () {
    var self = this;
    return LoginService.userObject.isInModules("AnalyticsForLync");
};

DataProvider.prototype.isRoomInsightsInModules = function () {
    var self = this;
    return LoginService.userObject.isInModules("RoomInsights");
};

DataProvider.prototype.getModuleDictionary = function() {
    let self = this;
    return {
        assurance: {
            isEnabled: self.assuranceIsInModules.bind(self),
            name: 'CPM Monitoring&reg;',
            clearPrefsName: 'Technology Insights Monitoring\u00ae',
            url: '#monitoring',
            icon: 'dist/images/monitor-heart-rate.svg',
            // status: 'alpha',
            // statusCss: 'beta badge',
            clearPrefs: function() {
                PreferenceService.clearPreferences('assurance').then(function() {
                    window.location.reload();
                });
            }
        },
        advancedAnalytics: {
            isEnabled: self.advancedAnalyticsIsInModules.bind(self),
            name: 'CPM Analytics&reg;',
            clearPrefsName: 'Technology Insights Analytics\u00ae',
            url: '#historical2',
            icon: 'dist/images/analytics.svg',
            clearPrefs: function() {
                PreferenceService.clearPreferences('historical2').then(function() {
                    window.location.reload();
                });
            }
        },
        roomInsights: {
          isEnabled: self.isRoomInsightsInModules.bind(self),
          name: 'Workspace Insights',
          clearPrefsName: 'Workspace Insights',
          url: '#rooms',
          icon: 'dist/images/door-open.svg',
          clearPrefs: function() {
              PreferenceService.clearPreferences('rooms').then(function() {
                  window.location.reload();
              });
          }
        },
    };
};
DataProvider.prototype.getListOfApps = function() {
    var self = this;
    var result = [];

    function addIfEnabled(module, list) {
        var moduleObj = _.get(self.getModuleDictionary(), module);
        if (!_.isEmpty(moduleObj)) {
            if (moduleObj.isEnabled() && !_.includes(self.markedForRemovalList, module)) {
                list.push({
                  name: moduleObj.name,
                  url: moduleObj.url,
                  clearPrefs: moduleObj.clearPrefs,
                  clearPrefsName: moduleObj.clearPrefsName,
                  icon: moduleObj.icon,
                });
            }
        }
    }

    addIfEnabled('advancedAnalytics', result);
    addIfEnabled('assurance', result);
    // addIfEnabled('historical', result);
    // addIfEnabled('lync', result);
    addIfEnabled('realtime', result);
    // addIfEnabled('webex', result);
    addIfEnabled('roomInsights', result);
    addIfEnabled('getStarted', result);

    return result;
};

DataProvider.prototype.markForRemoval = function (moduleId) {
    let self = this;
    self.markedForRemovalList.push(moduleId);
};

DataProvider.prototype.getDefaultLocation = function () {
    var self = this;
    var defaultLocation;

    if (!_.isEmpty(LoginService.userObject.landingUri)) {
        defaultLocation = LoginService.userObject.landingUri;
    } else if (self.assuranceIsInModules()) {
        defaultLocation = '#monitoring/dashboard';
    } else if (self.advancedAnalyticsIsInModules()) {
        defaultLocation = '#historical2/dashboard';
    } else if (self.isRoomInsightsInModules()) {
        defaultLocation = '#rooms';
    } else if (LoginService.userObject.isUserAdmin() || LoginService.userObject.isUserPro()) {
        defaultLocation = '#admin/welcome';
    } else {
        console.error('No modules defined');
        defaultLocation = '#';
    }
    return defaultLocation;
};

DataProvider.prototype.signOut = function(skipServiceCall) {
    var self = this;
    self.dataRepositoryManager.clearTimers();
    AssuranceDataService.dispose();
    self.resetDataProvider();
    // self.logActivity2('signingout', '', '', {}).finally(() => {
        sessionStorage.clear();
    // });
    if (!skipServiceCall) {
      LoginService.logout();
    }
};

DataProvider.prototype.registerDataConsumer = function (dataConsumer, dataSources, dataFormatterModule) {
    var self = this;

    if (!$.isEmptyObject(dataSources)) {
        self.dataRepositoryManager.registerDataSource(dataSources);
    }
    if (!$.isEmptyObject(dataFormatterModule)) {
        switch(dataFormatterModule.name) {
          //formatters
          case 'src/app/data-formatters/alertgrid-formatter': registerFormatter(alertgridFormatter, self); break;
          case 'src/app/data-formatters/callcontrolstatussearchgrid-formatter': registerFormatter(callcontrolstatussearchgridFormatter, self); break;
          case 'src/app/data-formatters/capacitystatusgrid-formatter': registerFormatter(capacitystatusgridFormatter, self); break;
          case 'src/app/data-formatters/capacitytrendchart-formatter': registerFormatter(capacitytrendchartFormatter, self); break;
          case 'src/app/data-formatters/endpointdetail-formatter': registerFormatter(endpointdetailFormatter, self); break;
          case 'src/app/data-formatters/endpointmgmtgrid-formatter': registerFormatter(endpointmgmtgridFormatter, self); break;
          case 'src/app/data-formatters/endpointstatusgrid-formatter': registerFormatter(endpointstatusgridFormatter, self); break;
          case 'src/app/data-formatters/endpointstatussearchgrid-formatter': registerFormatter(endpointstatussearchgridFormatter, self); break;
          case 'src/app/data-formatters/filter-formatter': registerFormatter(filterFormatter, self); break;
          case 'src/app/data-formatters/flexipanel-formatter': registerFormatter(flexipanelFormatter, self); break;
          case 'src/app/data-formatters/genericfilter-formatter': registerFormatter(genericfilterFormatter, self); break;
          case 'src/app/data-formatters/grid-formatter-common': registerFormatter(gridFormatterCommon, self); break;
          case 'src/app/data-formatters/historicalfilter-formatter': registerFormatter(historicalfilterFormatter, self); break;
          case 'src/app/data-formatters/historicalgraph-formatter': registerFormatter(historicalgraphFormatter, self); break;
          case 'src/app/data-formatters/integrations-formatter': registerFormatter(integrationsFormatter, self); break;
          case 'src/app/data-formatters/kpicell-formatter': registerFormatter(kpicellFormatter, self); break;
          case 'src/app/data-formatters/kpimulticell-formatter': registerFormatter(kpimulticellFormatter, self); break;
          case 'src/app/data-formatters/kpipanel-formatter': registerFormatter(kpipanelFormatter, self); break;
          case 'src/app/data-formatters/licenselinechart-formatter': registerFormatter(licenselinechartFormatter, self); break;
          case 'src/app/data-formatters/linechart-formatter-common': registerFormatter(linechartFormatterCommon, self); break;
          case 'src/app/data-formatters/logireport-formatter': registerFormatter(logireportFormatter, self); break;
          case 'src/app/data-formatters/lyncfilter-formatter': registerFormatter(lyncfilterFormatter, self); break;
          case 'src/app/data-formatters/qualitygraphs-formatter': registerFormatter(qualitygraphsFormatter, self); break;
          case 'src/app/data-formatters/qualitygrids-formatter': registerFormatter(qualitygridsFormatter, self); break;
          case 'src/app/data-formatters/roomgrid-formatter': registerFormatter(roomgridFormatter, self); break;
          case 'src/app/data-formatters/scheduled-meetings-formatter': registerFormatter(scheduledMeetingsFormatter, self); break;
          case 'src/app/data-formatters/schedulegrid-formatter': registerFormatter(schedulegridFormatter, self); break;
          case 'src/app/data-formatters/searchgrid2-formatter': registerFormatter(searchgrid2Formatter, self); break;
          case 'src/app/data-formatters/toputilizedgrid-formatter': registerFormatter(toputilizedgridFormatter, self); break;
          case 'src/app/data-formatters/xmldetails-formatter': registerFormatter(xmldetailsFormatter, self); break;
          default: registerFormatter(formatterCommon, self);
        }
    }

    function registerFormatter(dataFormatter, self) {
        var dfobj = new dataFormatter(dataFormatterModule.params, dataConsumer.observableOptions, dataSources, dataConsumer.id);

        var index = _.findIndex(self.dataConsumers, function (consumer) {
            return consumer.dataConsumer.id === dataConsumer.id && consumer.dataFormatter;
        });
        // only add if data consumer not added yet
        if (index === -1) {
            self.dataConsumers.push({
                dataConsumer: dataConsumer,
                dataFormatter: dfobj
            });
        }

        dfobj.initialize(self.dataRepositoryManager.dataRepository, self);
    }
};

DataProvider.prototype.refreshDataSources = function (dataSources) {
    this.dataRepositoryManager.refreshDataSources(dataSources);
};

DataProvider.prototype.hasCallControlDevices = function () {
    var self = this;
    return self.dataRepositoryManager.hasCallControlDevices();
};

DataProvider.prototype.hasBridges = function () {
    var self = this;
    return self.dataRepositoryManager.hasBridges();
};

DataProvider.prototype.hasEndpoints = function () {
    var self = this;
    return self.dataRepositoryManager.hasEndpoints();
};

DataProvider.prototype.getSystemDictionaryObservable = function () {
    var self = this;
    return self.dataRepositoryManager.getSystemDictionaryObservable();
};

DataProvider.prototype.getListOfEndpointsObservable = function () {
    var self = this;
    return self.dataRepositoryManager.getListOfEndpointsObservable();
};

DataProvider.prototype.getFlexPanelMetaDataObservable = function () {
    var self = this;
    return self.dataRepositoryManager.getFlexPanelMetaDataObservable();
};

DataProvider.prototype.getEndpointModelsObservable = function () {
    var self = this;
    return self.dataRepositoryManager.getEndpointModelsObservable();
};

DataProvider.prototype.getEndpointCallDataObservable = function () {
    var self = this;
    return self.dataRepositoryManager.getEndpointCallDataObservable();
};

DataProvider.prototype.getSystemsObservable = function () {
    var self = this;
    return self.dataRepositoryManager.getSystemsObservable();
};

DataProvider.prototype.getPexipLocationsObservable = function () {
    var self = this;
    return self.dataRepositoryManager.getPexipLocationsObservable();
};

DataProvider.prototype.getDictionaryOfBridgesWithIdsObservable = function () {
    var self = this;
    return self.dataRepositoryManager.getDictionaryOfBridgesWithIdsObservable();
};

DataProvider.prototype.getDictionaryOfCallControlsWithIdsObservable = function () {
    var self = this;
    return self.dataRepositoryManager.getDictionaryOfCallControlsWithIdsObservable();
};

DataProvider.prototype.getListOfEndpointsWithIdsObservable = function () {
    var self = this;
    return self.dataRepositoryManager.getListOfEndpointsWithIdsObservable();
};

DataProvider.prototype.getListOfTrunksWithIdsObservable = function() {
  var results = ko.observableArray();

  DataServiceSecure.fetchDataset('trunks', { page: 0 }).then(response => {
    response.content.forEach(trunk => { results.push(getTrunkIdAndName(trunk)); });
    results.push(_.map(response.content, getTrunkIdAndName));
    for (let i = 1, _i = response.totalPages; i < _i; i++) {
      DataServiceSecure.fetchDataset('trunks', { page: i }).then(response2 => {
        response2.content.forEach(trunk => { results.push(getTrunkIdAndName(trunk)); });
      });
    }
  });

  function getTrunkIdAndName(trunk) {
    return {
      name: trunk.name,
      id: trunk.trunk_id
    }
  }

  return results;
};

DataProvider.prototype.logActivity2 = function (action, source, details, data) {
    var self = this;

    var objActivity = {
        timestamp: new Date(),
        userId: _.get(LoginService.userObject, 'userId', ''),
        userName: _.get(LoginService.userObject, 'name', ''),
        userEmail: _.get(LoginService.userObject, 'email', ''),
        orgId: _.get(LoginService.userObject, 'orgId', ''),
        action: action,
        appId: _.get(self.currentRouteParams, 'page', ''),
        view: _.get(self.currentRouteParams, 'view', ''),
        tab: _.get(self.currentRouteParams, 'tabId', '0'),
        url: window.location.href,
        source: source,
        details: details,
        data: data ? ko.toJSON(data) : ko.toJSON(''),
    };

    DashboardService.logUserActivity(objActivity).catch((error) => {
      console.warn(error); // todo
    });
};

DataProvider.prototype.logAdminActivity = function (orgId, action, source, details, data) {
    var self = this;

    var objActivity = {
        timestamp: new Date(),
        userId: _.get(LoginService.userObject, 'userId', ''),
        userName: _.get(LoginService.userObject, 'name', ''),
        userEmail: _.get(LoginService.userObject, 'email', ''),
        orgId: _.get(LoginService.userObject, 'orgId', ''),
        action: action,
        appId: _.get(self.currentRouteParams, 'page', ''),
        view: _.get(self.currentRouteParams, 'view', ''),
        tab: _.get(self.currentRouteParams, 'tabId', '0'),
        url: window.location.href,
        source: source,
        details: details,
        data: data ? ko.toJSON(data) : ko.toJSON(''),
    };

    DashboardService.logAdminActivity(orgId, objActivity).catch((error) => {
      console.warn(error); // todo
    });
};

DataProvider.prototype.getQueryResultJson = function (queryId, paramsJson) {
    var self = this;
    return self.dataRepositoryManager.invokeServiceMethod2("DatabaseMethods.aspx", "GetQueryResultJson", "json", {
        queryId: queryId,
        paramsJson: paramsJson,
        url: $(location).attr("href")
    });
};

DataProvider.prototype.getQueryResultDatasetJson = function (queryId, paramsJson) {
    var self = this;
    return self.dataRepositoryManager.invokeServiceMethod2("DatabaseMethods.aspx", "GetQueryResultDatasetJson", "json", {
        queryId: queryId,
        paramsJson: paramsJson,
        url: $(location).attr("href")
    });
};

DataProvider.prototype.updateEndpoint = function (id, data) {
    var self = this;
    return self.dataRepositoryManager.invokeServiceMethod2("WebMethods.aspx", "UpdateEndpoint", "json", {
        endpointId: id,
        endpointData: data
    });
};

DataProvider.prototype.updateRooms = function (data) {
    var self = this;
    var roomsData = data;
    return self.dataRepositoryManager.invokeServiceMethod2("WebMethods.aspx", "UpdateRooms", "json", roomsData);
};

DataProvider.prototype.getOrgPreferences = function (key) {
    // bypass invokeServiceMethod2 which does post processing
    return DashboardService.fetchOrgPreferences({
        key: key
    });
};

DataProvider.prototype.addCiscoSparkBotToSpace = function (token, roomId) {
    var self = this;
    return self.dataRepositoryManager.invokeServiceMethod2("CiscoSparkIntegration.aspx", "AddBotToSpace", "json", {
        token: token,
        roomId: roomId
    });
};

DataProvider.prototype.removeCiscoSparkBotFromSpace = function (token, membershipId) {
    var self = this;
    return self.dataRepositoryManager.invokeServiceMethod2("CiscoSparkIntegration.aspx", "RemoveBotFromSpace", "string", {
        token: token,
        membershipId: membershipId
    });
};

DataProvider.prototype.getCiscoSparkBotSpaceMembership = function (token, roomId) {
    var self = this;
    return self.dataRepositoryManager.invokeServiceMethod2("CiscoSparkIntegration.aspx", "GetBotSpaceMembership", "json", {
        token: token,
        roomId: roomId
    });
};

DataProvider.prototype.getCiscoSparkBotSpaceMemberships = function () {
    var self = this;
    return self.dataRepositoryManager.invokeServiceMethod2("CiscoSparkIntegration.aspx", "GetBotSpaceMemberships", "json", {});
};

DataProvider.prototype.saveOrgPreferences = function (key, value) {
    var self = this;
    return self.dataRepositoryManager.invokeServiceMethod2("WebMethods.aspx", "SaveOrgPreferences", "json", {
        key: key,
        value: value
    });
};

DataProvider.prototype.addExportRegistration = function (appId, value) {
    var self = this;
    return self.dataRepositoryManager.invokeServiceMethod2("ExportRegistrations.aspx", "AddExportRegistration", "string", {
        appId: appId,
        value: JSON.stringify(value)
    });
};

DataProvider.prototype.updateExportRegistration = function (appId, value) {
    var self = this;
    return self.dataRepositoryManager.invokeServiceMethod2("ExportRegistrations.aspx", "UpdateExportRegistration", "string", {
        appId: appId,
        value: JSON.stringify(value)
    });
};

DataProvider.prototype.deleteExportRegistration = function (appId, id) {
    var self = this;
    return self.dataRepositoryManager.invokeServiceMethod2("ExportRegistrations.aspx", "DeleteExportRegistration", "string", {
        appId: appId,
        id: id
    });
};

DataProvider.prototype.getTokenParams = function (token) {
    var self = this;
    return self.dataRepositoryManager.invokeServiceMethod2("LinkMethods.aspx", "GetJson", "json", {
        url: $(location).attr("href"),
        token: token
    });
};

DataProvider.prototype.getObservableData = function (dataConsumer) {
    var self = this;

    for (var i = 0; i < self.dataConsumers.length; i++) {
        var currConsumer = self.dataConsumers[i];

        if ((currConsumer.dataConsumer.id === dataConsumer.id) && (currConsumer.dataFormatter)) {
            return currConsumer.dataFormatter.getObservableData();
        }
    }
};

DataProvider.prototype.unregisterDataConsumer = function (dataConsumerId) {
    var self = this;

    var index = _.findIndex(self.dataConsumers, function (consumer) {
        return consumer.dataConsumer.id === dataConsumerId && consumer.dataFormatter;
    });
    if (index !== -1) {
        self.dataConsumers[index].dataFormatter.dispose();
        self.dataConsumers.splice(index, 1);
    }
};

DataProvider.prototype.dispose = function () {
    var self = this;

    if (self.dataRepositoryManager) {
        self.dataRepositoryManager.dispose();
        self.dataConsumers = [];
        self.preferenceManager.dispose();
        self.preferences = {};
        self.markedForRemovalList = [];

        delete self.dataRepositoryManager;
        delete self.dataConsumers;
        delete self.preferenceManager;
        delete self.preferences;
    }
    if (self.subscription) { self.subscription.dispose(); delete self.subscription; }
};

DataProvider.prototype.fetchLoggingServiceBaseURL = function () {
    var self = this;
    return ConfigService.getInstance().getLoggingService().then(function (serviceUrl) {
        return serviceUrl + "/logging/api/v1/orgs/" + LoginService.userObject.orgId;
    });
};

DataProvider.prototype.fetchAssuranceDashboardServiceBaseURL = function () {
    var self = this;
    return ConfigService.getInstance().getDashboardService().then(function (serviceUrl) {
        return serviceUrl + "/dashboard/api/v1/orgs/" + LoginService.userObject.orgId;
    });
};

DataProvider.prototype.fetchAssuranceDashboardServiceV2BaseURL = function () {
    var self = this;
    return ConfigService.getInstance().getDashboardService().then(function (serviceUrl) {
        return serviceUrl + "/dashboard/api/v2/orgs/" + LoginService.userObject.orgId;
    });
};

DataProvider.prototype.fetchAssurancePreferencesServiceBaseURL = function () {
    var self = this;
    return ConfigService.getInstance().getAssurancePreferenceService().then(
        function (serviceUrl) {
            return serviceUrl
                + "/cpmm/api/v1/orgs/" + LoginService.userObject.orgId;
        });
};

DataProvider.prototype.fetchAssuranceCiscoSparkServiceBaseURL = function () {
    var self = this;
    return ConfigService.getInstance().getDashboardService().then(function (serviceUrl) {
        return serviceUrl + "/ciscospark/api/v1";
    });
};

DataProvider.prototype.fetchAssuranceQueryServiceBaseURL = function () {
    var self = this;
    return ConfigService.getInstance().getAssuranceQueryService().then(function (serviceUrl) {
        return serviceUrl + "/cpmm/api/v1/orgs/" + LoginService.userObject.orgId;
    });
};

DataProvider.prototype.fetchAssuranceMdmServiceBaseURL = function () {
    var self = this;
    return ConfigService.getInstance().getAssuranceMdmService().then(function (serviceUrl) {
        return serviceUrl + "/mdm/api/v2/orgs/" + (window.location.href.match('#[\\/]?admin\\/') ? (store.getters['user/getOrgContext'] || store.getters['user/getOrgId']) : LoginService.userObject.orgId);
    });
};

DataProvider.prototype.fetchAssuranceAdrServiceBaseURL = function () {
    var self = this;
    return ConfigService.getInstance().getAssuranceMdmService().then(function (serviceUrl) { // todo use ADR vs MDM
        return serviceUrl + "/adr/api/v1/orgs/" + (window.location.href.match('#[\\/]?admin\\/') ? (store.getters['user/getOrgContext'] || store.getters['user/getOrgId']) : LoginService.userObject.orgId);
    });
};

DataProvider.prototype.fetchAssuranceAdrServiceSuBaseURL = function () {
    var self = this;
    return ConfigService.getInstance().getAssuranceMdmService().then(function (serviceUrl) { // todo use ADR vs MDM
        return serviceUrl + "/adr/api/v1";
    });
};

DataProvider.prototype.fetchAssuranceAlertConfigServiceBaseURL = function () {
    var self = this;
    return ConfigService.getInstance().getAssuranceAlertConfigService().then(function (serviceUrl) {
        return serviceUrl + "/cpmm/api/v1/orgs/" + LoginService.userObject.orgId;
    });
};

DataProvider.prototype.fetchAssuranceQueryServiceV2BaseURL = function () {
    var self = this;
    return ConfigService.getInstance().getAssuranceQueryService().then(function (serviceUrl) {
        return serviceUrl + "/cpmm/api/v2/orgs/" + LoginService.userObject.orgId;
    });
};

DataProvider.prototype.fetchAssuranceAppsServiceBaseURL = function () {
    var self = this;
    return self.fetchAssuranceAppsServiceBaseURLForOrg(LoginService.userObject.orgId);
};

DataProvider.prototype.fetchAssuranceAppsServiceBaseURLForOrg = function (orgId) {
    var self = this;
    return ConfigService.getInstance().getAssuranceAppsService().then(function (serviceUrl) {
        return serviceUrl + "/cpmm/apps/api/v1/orgs/" + orgId;
    });
};

DataProvider.prototype.fetchAssuranceAppsServiceBaseBaseURL = function () {
    return ConfigService.getInstance().getAssuranceAppsService().then(function (serviceUrl) {
        return serviceUrl + "/cpmm/apps/api/v1";
    });
};

DataProvider.prototype.fetchAssuranceAppsServiceV2BaseBaseURL = function () {
    return ConfigService.getInstance().getAssuranceAppsService().then(function (serviceUrl) {
        return serviceUrl + "/cpmm/apps/api/v2";
    });
};

DataProvider.prototype.fetchAdminServiceBaseBaseURL = function () {
    return ConfigService.getInstance().getAdminService().then(function (serviceUrl) {
        return serviceUrl + "/admin/api/v1";
    });
};

DataProvider.prototype.fetchPreferencesServicePreferencesBaseURLForAppAndUser = function (appId, userId) {
  return this.fetchPreferencesServicePreferencesBaseURLForAppAndOrgAndUser(appId, LoginService.userObject.orgId, userId);
}

DataProvider.prototype.fetchPreferencesServicePreferencesBaseURLForAppAndOrgAndUser = function (appId, orgId, userId) {
    var self = this;
    if (!userId) return self.fetchPreferenceServiceBaseURL(appId);

    return ConfigService.getInstance().getAssurancePreferenceService().then(
        function (serviceUrl) {
            return serviceUrl
                +"/cpmm/api/v1/orgs/" + orgId + '/users/'
                + userId + '/preferences/' + appId;
        });
};

DataProvider.prototype.fetchPreferenceServiceBaseURL = function (appId) {
  var self = this;
  return ConfigService.getInstance().getAssurancePreferenceService().then(function(serviceUrl) {
    return serviceUrl + "/cpmm/api/v1/orgs/" + LoginService.userObject.orgId + '/users/'
      + LoginService.userObject.userId + '/preferences/' + appId;
  });
};

DataProvider.prototype.fetchPreferenceServiceBaseURLForUser = function (orgId, userId, appId) {
  var self = this;
  return ConfigService.getInstance().getAssurancePreferenceService().then(function(serviceUrl) {
    return serviceUrl + "/cpmm/api/v1/orgs/" + orgId + '/users/'
      + userId + '/preferences/' + appId;
  });
}

DataProvider.prototype.fetchApiGatewayBaseURL = function () {
    return ConfigService.getInstance().getAssuranceQueryService();
};

DataProvider.prototype.isInternalUser = function () {
    var self = this;
    return LoginService.userObject.orgId === 1
        || _.startsWith(LoginService.userObject.email, 'vyoptaadmin@')
        || LoginService.userObject.email === 'support@vyopta.com';
};

DataProvider.getInstance = function () {
    if (!instance) {
        instance = new DataProvider();
    }
    return instance;
};

export default DataProvider;
